import React, { useEffect, useState } from "react"
import ReactDatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { useForm, Controller } from "react-hook-form"
import styled from "styled-components"
import Recaptcha from "react-recaptcha"
import { Loading } from "./loading"
import useSSR from "use-ssr"

const DesignerForm = ({ location }) => {
  const [submitted, setSubmitted] = useState(false)
  const [failed, setFailed] = useState(false)
  const [CaptchaFailed, setCaptchaFailed] = useState(false)
  const [checkedAll, setCheckedAll] = useState(false)
  // const [captcha, setCaptcha] = useState(true)
  const [checked, setChecked] = useState({
    nr1: false,
    nr2: false,
    nr3: false,
    nr4: false,
    nr5: false,
    nr6: false,
    nr7: false,
    nr8: false,
    nr9: false,
  })

  /* ################################################ */
  /* #### TOGGLES checK STATE BASED ON inputName #### */
  /* ################################################ */

  const toggleCheck = inputName => {
    setChecked(prevState => {
      const newState = { ...prevState }
      newState[inputName] = !prevState[inputName]
      return newState
    })
  }

  /* ###################################################### */
  /* #### CHECKS OR UNCHECKS ALL FROM SELECT ALL CLICK #### */
  /* ###################################################### */

  const selectAll = value => {
    setCheckedAll(value)
    setChecked(prevState => {
      const newState = { ...prevState }
      for (const inputName in newState) {
        newState[inputName] = value
      }
      return newState
    })
  }

  /* ############################################# */
  /* #### EFFECT TO CONTROL CHECKED_ALL STATE #### */
  /* ############################################# */

  // IF YOU CHECK BOTH INDIVIDUALLY. IT WILL ACTIVATE THE checkedAll STATE
  // IF YOU UNCHECK ANY INDIVIDUALLY. IT WILL DE-ACTIVATE THE checkAll STATE

  useEffect(() => {
    let allChecked = true
    for (const inputName in checked) {
      if (checked[inputName] === false) {
        allChecked = false
      }
    }
    if (allChecked) {
      setCheckedAll(true)
    } else {
      setCheckedAll(false)
    }
  }, [checked])

  const [cloudLinks, setCloudLinks] = useState([])
  const [captchaValue, setCaptchaValue] = useState(null)

  const clickMe = () => {
    const isBrowser = typeof window !== "undefined"

    if (!isBrowser) {
      return
    }
    console.log(window.cloudinary) //
    let widget = window.cloudinary.createUploadWidget(
      {
        cloudName: `https-studioconscious-com`,
        sources: ["local", "url"],
        uploadPreset: `studio`,
      },
      (error, result) => {
        if (!error && result && result.event === "success") {
          // console.log(result.info.url)
          // setCloudLinks([...cloudLinks, result.info.url])
          setCloudLinks(state => [...state, result.info.url])
        }
      }
    )
    widget.open() //
  }

  const removeImage = e => {
    const arrayIndex = e.target.getAttribute("name")
    // console.log(cloudLinks)
    // console.log(cloudLinks[arrayIndex])
    setCloudLinks(cloudLinks.filter(item => item !== cloudLinks[arrayIndex]))
  }

  const [close, setClose] = useState(false)

  const toggleCart = () => {
    setClose(!close)
  }
  const showCart = () => {
    setClose(true)
  }

  let fetchUrl
  if (location.origin === "http://localhost:8000") {
    fetchUrl = `http://localhost:8888/.netlify/functions/concepts-email`
  } else if (location.origin === "http://dev.studioconscious.com") {
    fetchUrl = `https://studioconscious-dev.netlify.app/.netlify/functions/concepts-email`
  } else {
    fetchUrl = "/.netlify/functions/concepts-email"
  }

  const [submitButton, setSubmitButton] = useState(true)

  const { register, handleSubmit, errors, control, reset } = useForm()
  const onSubmit = async data => {
    let dataMassage = {
      ...data,
      cloudLinks: cloudLinks,
      captcha: captchaValue,
    }

    console.log(captchaValue)

    const response = await fetch(fetchUrl, {
      method: "POST",
      body: JSON.stringify({
        dataMassage,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.message) {
          setSubmitted(true)
          setSubmitButton(true)
          // setCaptcha(false)
        } else {
          setFailed(true)
          setCaptchaFailed(true)
        }
        return data
      })
      .catch(error => {
        setFailed(true)
        console.error("Error:", error)
      })

    console.log("response")

    console.log(response)
    console.log("response")
  }
  console.log(errors)

  var verifyCallback = function (response) {
    console.log("check")
    setCaptchaValue(response)
    setSubmitButton(false)
  }

  let recaptchaInstance

  const clickReset = () => {
    setSubmitted(false)
    // setCaptcha(true)
    reset({})
    setCloudLinks(false)
    recaptchaInstance.reset()
    setChecked({
      nr1: false,
      nr2: false,
      nr3: false,
      nr4: false,
      nr5: false,
      nr6: false,
      nr7: false,
      nr8: false,
      nr9: false,
    })
  }

  var { isBrowser } = useSSR()

  const [startDate, setStartDate] = useState(new Date())

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <DesignerInfo>
        <ProcessTitle>Personal Information</ProcessTitle>
        <NameGrid>
          <div>
            <h4>Full Name</h4>
            <input type="text" placeholder="name" name="name" ref={register} />
          </div>
          <div>
            <h4>Company Name</h4>
            <input
              type="text"
              placeholder="company"
              name="company"
              ref={register}
            />
          </div>
          <div>
            <h4>Email Address</h4>
            <input
              type="email"
              placeholder="email"
              name="email"
              ref={register}
            />
          </div>
        </NameGrid>
      </DesignerInfo>
      <ProjectInfo>
        <hr />
        <ProcessTitle>Project Information</ProcessTitle>

        <NameGrid1>
          <div className="projectWrap">
            <h4>Project Title</h4>
            <h3 className="time">What is the title of this project</h3>
            <input
              type="text"
              placeholder="project title"
              name="projectTitle"
              ref={register}
            />
          </div>
          <div className="timeWrap">
            <h4>Approximate Timeline</h4>
            <h3 className="time">
              Approximate date you would need all products
            </h3>
            <Controller
              name="purchaseDate"
              control={control}
              render={({ onChange, value }) => (
                <ReactDatePicker
                  placeholderText="click here"
                  selected={value}
                  onChange={onChange}
                />
              )}
            />
          </div>
          <div className="uploadMe">
            <h4>Upload your design materials or inspiration pictures</h4>
            <button
              type="button"
              onClick={clickMe}
              id="upload_widget"
              className="upload"
            >
              Upload files
            </button>
            <ImgGrid>
              {cloudLinks &&
                cloudLinks.map((img, i) => {
                  return (
                    <div className="imgPreview" key={i}>
                      <button className="close" name={i} onClick={removeImage}>
                        X
                      </button>
                      <img src={img} />
                    </div>
                  )
                })}
            </ImgGrid>
          </div>
        </NameGrid1>
        <NameGrid2>
          <section>
            <h3>Intended Rooms</h3>
            <CheckGrid>
              <span>All</span>
              <input
                type="checkbox"
                name="all"
                ref={register}
                onChange={event => selectAll(event.target.checked)}
                checked={checkedAll}
              />
            </CheckGrid>
            <CheckGrid>
              <span>Entire House</span>
              <input
                type="checkbox"
                placeholder="entireHouse"
                name="entireHouse"
                ref={register}
                onChange={() => toggleCheck("nr1")}
                checked={checked["nr1"]}
              />
            </CheckGrid>
            <CheckGrid>
              <span>Living Room</span>
              <input
                type="checkbox"
                placeholder="livingRoom"
                name="livingRoom"
                ref={register}
                onChange={() => toggleCheck("nr2")}
                checked={checked["nr2"]}
              />
            </CheckGrid>
            <CheckGrid>
              <span>Kitchen</span>
              <input
                type="checkbox"
                placeholder="kitchen"
                name="kitchen"
                ref={register}
                onChange={() => toggleCheck("nr3")}
                checked={checked["nr3"]}
              />
            </CheckGrid>
            <CheckGrid>
              <span>Dining Room</span>
              <input
                type="checkbox"
                placeholder="diningRoom"
                name="diningRoom"
                ref={register}
                onChange={() => toggleCheck("nr4")}
                checked={checked["nr4"]}
              />
            </CheckGrid>
            <CheckGrid>
              <span>Bedrooms</span>
              <input
                type="checkbox"
                placeholder="bedrooms"
                name="bedrooms"
                ref={register}
                onChange={() => toggleCheck("nr5")}
                checked={checked["nr5"]}
              />
            </CheckGrid>
            <CheckGrid>
              <span>Bathroom</span>
              <input
                type="checkbox"
                placeholder="bathroom"
                name="bathroom"
                ref={register}
                onChange={() => toggleCheck("nr6")}
                checked={checked["nr6"]}
              />
            </CheckGrid>
            <CheckGrid>
              <span>Bonus Room</span>
              <input
                type="checkbox"
                placeholder="bonusRoom"
                name="bonusRoom"
                ref={register}
                onChange={() => toggleCheck("nr7")}
                checked={checked["nr7"]}
              />
            </CheckGrid>
            <CheckGrid>
              <span>Entry</span>
              <input
                type="checkbox"
                placeholder="entry"
                name="entry"
                ref={register}
                onChange={() => toggleCheck("nr8")}
                checked={checked["nr8"]}
              />
            </CheckGrid>
            <CheckGrid>
              <span>Mudroom / Laundry Room</span>
              <input
                type="checkbox"
                placeholder="mudroomLaundryRoom"
                name="mudroomLaundryRoom"
                ref={register}
                onChange={() => toggleCheck("nr9")}
                checked={checked["nr9"]}
              />
            </CheckGrid>
          </section>
          <section>
            <h3>Approximate Budget</h3>
            <CheckGrid>
              <span>$150-200</span>
              <input
                name="approximateBudget"
                type="radio"
                value="150-200"
                ref={register}
              />
            </CheckGrid>
            <CheckGrid>
              <span>$250-350</span>
              <input
                name="approximateBudget"
                type="radio"
                value="250-350"
                ref={register}
              />
            </CheckGrid>
            <CheckGrid>
              <span>$350-450</span>
              <input
                name="approximateBudget"
                type="radio"
                value="350-450"
                ref={register}
              />
            </CheckGrid>
            <CheckGrid>
              <span>$450-550</span>
              <input
                name="approximateBudget"
                type="radio"
                value="450-550"
                ref={register}
              />
            </CheckGrid>
            <CheckGrid>
              <span>$550-650</span>
              <input
                name="approximateBudget"
                type="radio"
                value="$550+"
                ref={register}
              />
            </CheckGrid>
            <CheckGrid>
              <span>$650+</span>
              <input
                name="approximateBudget"
                type="radio"
                value="$550+"
                ref={register}
              />
            </CheckGrid>
          </section>
        </NameGrid2>

        <Name>
          <h3>Optional Note</h3>
          <textarea name="optionalNote" ref={register} />
        </Name>
      </ProjectInfo>
      {/* {captcha && ( */}
      <CaptchaWrap>
        {isBrowser && (
          <Recaptcha
            sitekey="6Lfy8IsaAAAAABtlygRFNbIuveZ_BavtLJcubRf6"
            verifyCallback={verifyCallback}
            ref={e => (recaptchaInstance = e)}
          />
        )}
      </CaptchaWrap>
      {/* )} */}
      <Loading>
        {submitted && (
          <Success>
            <h1>Succesfully submitted</h1>
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                className="checkmark__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="checkmark__check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
            <button onClick={clickReset}>
              Click to reset, and then fill form again
            </button>
          </Success>
        )}
        {failed && (
          <Failed>
            {CaptchaFailed && (
              <p>
                It looks like the reCaptcha checkbox failed, try checking it
                again, or try below
              </p>
            )}
            <h1>Email Failed Contact us here </h1>
            <h2>
              <a href="mailto:hello@studioconscious.com">
                hello@studioconscious.com
              </a>
            </h2>
          </Failed>
        )}
      </Loading>
      <input
        disabled={submitButton ? "disabled" : ""}
        // className="submit"
        className={submitButton ? "disabled submit" : "submit"}
        type="submit"
      />
    </Form>
  )
}

const Form = styled.form`
  width: 85%;
  margin: 0 auto;
  background: #f2f1ef;
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 50px;
  padding-bottom: 25px;
  @media (max-width: 600px) {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
  h4,
  .time {
    font-family: raleway, courier;
  }
  .time {
    font-style: italic;
    font-size: 12px;
  }
  input {
    padding: 15px;
    border-radius: 10px;
    border: 1px solid lightgray;
    width: 250px;
    @media (max-width: 600px) {
      width: 100%;
    }
  }
  .submit {
    margin: 50px auto;
    display: block;
    background: #8f9687;
    &:hover {
      cursor: pointer;
    }
    &.disabled {
      background: lightgrey;
      color: #000;
      &:hover {
        cursor: not-allowed;
      }
    }
    &:focus {
      outline: none;
    }
    @media (max-width: 600px) {
      width: 50%;
    }
  }
`

const CheckGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 300px;
  @media (max-width: 450px) {
    width: 230px;
  }
  input {
    width: initial;
  }
`

const ImgGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 300px;
  margin: 0 auto;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    width: 100px;
  }
  img {
    width: 100%;
  }
`

const NameGrid = styled.div`
  div {
    @media (max-width: 600px) {
      width: 75%;
    }
  }
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  @media (max-width: 1225px) {
    grid-template-columns: 1fr;
  }
`

const NameGrid1 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  .timeWrap {
    @media (max-width: 600px) {
      width: 75%;
    }
  }
  .projectWrap {
    @media (max-width: 600px) {
      width: 75%;
    }
  }
  @media (max-width: 1225px) {
    grid-template-columns: 1fr;
  }
  .uploadMe {
    grid-column: 1 / -1;
    margin: 25px 0;
    h4 {
      @media (max-width: 600px) {
        text-align: center;
      }
    }
  }
  button.upload {
    margin: 0 auto;
    display: block;
    padding: 15px;
    border-radius: 10px;
    border: none;
    background: #8f9687;
    margin-bottom: 20px;
    margin-top: 20px;
    &:hover {
      cursor: pointer;
    }
  }
  .imgPreview {
    margin: 10px;
  }
  h4 {
    margin-bottom: 0;
  }
`

const NameGrid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  @media (max-width: 1225px) {
    grid-template-columns: 1fr;
  }
  section {
    width: 250px;
    @media (max-width: 1225px) {
      width: 168px;
    }
    h3 {
      font-family: Raleway, arial;
      font-size: 16px;
      font-weight: 700;
    }
  }
`

const Name = styled.section`
  margin: 50px auto;
  width: 400px;
  @media (max-width: 500px) {
    width: 75%;
  }
  textarea {
    width: 100%;
    height: 75px;
    resize: none;
    padding: 15px;
    border-radius: 10px;
    border: 1px solid lightgray;
  }
  h3 {
    font-family: Raleway, arial;
    font-size: 16px;
    font-weight: 700;
  }
`

const DesignerInfo = styled.div`
  h2 {
    font-size: 22px;
  }
`

const ProjectInfo = styled.div`
  h2 {
    font-size: 22px;
    padding-bottom: 40px;
    margin-top: 25px;
  }
  hr {
    margin-top: 50px;
  }
`

const ProcessTitle = styled.h2`
  text-align: center;
  font-size: 36px;
  font-family: "Playfair Display";
`

const CaptchaWrap = styled.div`
  margin: 0 auto;
  div {
    margin: 50px auto;
  }
`

const Success = styled.div`
  text-align: center;
  svg {
    width: 50px;
    margin: 0 auto;
  }
`

const Failed = styled.div`
  text-align: center;
`

export default DesignerForm
